// action - state management
import { ISP_INFO } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  ispInfo: null
};

// eslint-disable-next-line
const ispReducer = (state = initialState, action) => {
  switch (action.type) {
    case ISP_INFO: {
      return {
        ...state,
        ispInfo: action.payload
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default ispReducer;
